import { ChangeDetectionStrategy, Component, Inject, Input, TemplateRef } from "@angular/core";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { PERSONAL_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { IAdaptLinkObject } from "@common/route/route.service";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";
import { PersonFlagService } from "@org-common/lib/person/person-flag.service";
import { Observable, switchMap } from "rxjs";
import { ICalendarProvider } from "../../calendar/calendar.interface";
import { OAuthService } from "../../oauth/oauth.service";

@Component({
    selector: "adapt-meeting-integration-prompt",
    templateUrl: "./meeting-integration-prompt.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class MeetingIntegrationPromptComponent extends BaseComponent {
    @Input() public disabled = false;
    @Input() public alwaysShown = false;
    @Input() public showLocal = false;
    @Input() public linkDisabled = false;
    @Input() public contentTemplate?: TemplateRef<any>;
    @Input() public isDismissible = false;

    public readonly ConfigArea = ConfigArea;
    public calendarProvider?: ICalendarProvider;
    public showTextPrompt = true;
    public personalConfigRoute?: IAdaptLinkObject;
    public meetingCalendarIntegrationDismissed$: Observable<boolean>;

    public constructor(
        public oauthService: OAuthService,
        @Inject(PERSONAL_CONFIGURATION_PAGE) public personalConfigurationPageRoute: IAdaptRoute<any>,
        private dialogService: AdaptCommonDialogService,
        private personFlagService: PersonFlagService,
    ) {
        super();

        this.meetingCalendarIntegrationDismissed$ = personFlagService.isFlagEnabled$(PersonFlag.MeetingCalendarIntegrationDismissed);
        this.personalConfigurationPageRoute.getRouteObject().subscribe((route) => {
            this.personalConfigRoute = route;
        });

        this.oauthService.authProvider$.pipe(
            this.takeUntilDestroyed(),
        ).subscribe((provider) => {
            this.calendarProvider = provider;
            this.showTextPrompt = !this.oauthService.hasPreviouslyLoggedInWithProvider(provider?.id);
        });
    }

    public dismissPrompt() {
        this.dialogService.openConfirmationDialog({
            title: "Dismiss calendar integration prompt",
            message: `<p>Are you sure you want to dismiss the calendar integration prompt? It will no longer appear for you in any teams.</p>
            <p>You can re-enable this prompt in your personal configuration under 'Calendar Integration'.</p>`,
            confirmButtonText: "Dismiss",
        }).pipe(
            switchMap(() => this.personFlagService.setFlagAndSave(PersonFlag.MeetingCalendarIntegrationDismissed, true)),
            this.takeUntilDestroyed(),
        ).subscribe();
    }
}
